import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "./firebase";

const EditTextDialog = ({ open, onClose, essay, onUpdate }) => {
  const [newName, setNewName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (essay) {
      setNewName(essay.fileName);
    }
  }, [essay]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newName.trim() || loading) return;

    setLoading(true);
    try {
      const essayRef = doc(db, "essays", essay.id);
      await updateDoc(essayRef, {
        fileName: newName.trim(),
      });
      onUpdate();
      onClose();
    } catch (error) {
      console.error("Error updating essay name:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Redigera namn på text</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              autoFocus
              label="Namn på text"
              fullWidth
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              variant="outlined"
              disabled={loading}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="print" onClick={onClose} disabled={loading}>
            Avbryt
          </Button>
          <Button
            type="submit"
            variant="purp"
            disabled={!newName.trim() || loading}
          >
            Spara
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditTextDialog;
